import axios from 'axios'
import { Message } from 'element-ui'
import {
  getToken,
  getUsername,
  getLoginTimes,
  setLoginTimes,
  getuserCurrentApp,
  setTempAppid,
  getTempAppid, removeIsSingleEntry, removeTempAppid, removeuserCurrentApp
} from '@/utils/cookies'
import { UserModule } from '@/store/modules/user'
import { getAppid } from '@/utils/utils'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 50000
  // withCredentials: true // send cookies when cross-domain requests
})

// Request interceptors
service.interceptors.request.use(
  (config) => {
    // Add Token header to every request
    config.headers.Authorization = 'Token ' + getToken()
    config.headers['X-Username'] = getUsername()
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response) => {
    const res = response.data
    console.log(res)
    if (response.headers['content-type'] === 'application/vnd.ms-excel') {
      return response.data
    }

    if (res.stat !== 1) {
      Message({
        message: res.data || res.msg || '请稍后重试',
        type: 'error',
        duration: 3 * 1000,
        showClose: true
      })
      return Promise.reject(res)
    } else {
      return response.data
    }
  },
  (error) => {
    let message = ''
    if (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.stat !== 1 &&
      (error.response.data.msg || error.response.data.data)
    ) {
      message = JSON.stringify(
        error.response.data.msg || error.response.data.data
      )
    }
    if (error && error.response) {
      let appid = getuserCurrentApp()

      switch (error.response.status) {
        case 400:
          error.message = `400：请求错误: ${message}`
          break
        case 401:
          error.message = '登录已过期，请重新登录'
          UserModule.ResetToken()
          removeIsSingleEntry()
          removeTempAppid()
          removeuserCurrentApp()
          const hashPath = (window as any).location.hash.substring(1) as any
          const loginTimes = Number(getLoginTimes())
          if (appid) {
            setTempAppid(appid)
          } else {
            appid = getTempAppid()
          }
          if (loginTimes > 1) {
            // 尝试登录2次，第3次不跳转
            error.message = '知音楼登录错误，请稍后重试！'
            UserModule.ResetToken()
          } else {
            // 知音楼内访问走sso统一登陆方式
            setLoginTimes((Number(getLoginTimes()) + 1).toString())

            Message.error({
              duration: 3 * 1000,
              message: error.message || '请求错误，请稍后重试。',
              showClose: true
            })

            if (appid) {
              setTempAppid(appid)
            } else {
              appid = getTempAppid()
            }

            if (appid) {
              if (appid === '5') {
                return ((window as any).location =
                  process.env.VUE_APP_ADMINI_LOGIN_API +
                  (hashPath
                    ? `?redirect=${encodeURIComponent(hashPath)}`
                    : ''))
              } else if (appid === '1') {
                return ((window as any).location =
                  process.env.VUE_APP_LOGIN_API +
                  (hashPath
                    ? `?redirect=${encodeURIComponent(hashPath)}`
                    : ''))
              }
            } else {
              const path = '/createIndex'
              return ((window as any).location =
                process.env.VUE_APP_LOGIN_API +
                (path ? `?redirect=${encodeURIComponent(path)}` : ''))
            }
          }

          break
        case 403:
          error.message = '403：无权限访问'
          break
        case 404:
          error.message = `404：请求地址出错: ${error.response.config.url}`
          break
        case 408:
          error.message = '408：请求超时，请稍后重试'
          break
        case 500:
          error.message = '500：服务错误，请稍后重试'
          break
        case 501:
          error.message = '501：服务未实现'
          break
        case 502:
          error.message = '502：网关错误，请稍后重试'
          break
        case 503:
          error.message = '503：服务不可用，请稍后重试'
          break
        case 504:
          error.message = '504：网关超时，请稍后重试'
          break
        case 505:
          error.message = '505：HTTP版本不受支持'
          break
        default:
          error.message = '请求错误，请稍后重试～'
          break
      }
    }
    Message.error({
      duration: 3 * 1000,
      message: error.message || '请求错误，请稍后重试。',
      showClose: true
    })
    return Promise.reject(error)
  }
)

export default service
